module.exports = __webpack_public_path__ + "img/about_member_maina.ba8f79b2.png";